import { ActionDp, getActionDp, LogOptions } from 'telemetry';
import { AppError } from './AppError';
import { getGuid } from 'owa-guid';
import { ListenerType } from './ListenerType';
import { MiddlewareType } from './MiddlewareType';

/**
 * Object that can carry the application context during a workflow.
 */
export class AppContext {
    cId: string;
    dpObj: ActionDp;

    static middlewares: MiddlewareType[] = [];
    static listeners: ListenerType[] = [];

    constructor() {
        this.cId = getGuid();
        this.dpObj = null;
    }

    startTracking(eventName: string, options?: LogOptions) {
        if (this.dpObj) {
            throw new Error('The tracking has already been started in this ctx');
        }
        this.dpObj = getActionDp(eventName, options);
    }

    /**
     * Method that can be used to send a signal which can later be intercepted by the app middlewares.
     * @param name name of signal.
     * @param inputPayload optional payload info for the signal.
     */
    signal(name: string, inputPayload?: any, options?: LogOptions, error?: AppError) {
        const payload = inputPayload || {};
        payload.cId = this.cId;
        const listeners = AppContext.listeners;
        listeners.map(listener => {
            listener(
                {
                    name: name,
                    customData: payload,
                    actionSource: options?.actionSource,
                    options,
                },
                this,
                error
            );
        });
    }
}
